import RouteSuggestionItem from "./RouteSuggestionItem";

export default function RouteSuggestionSection({ sections, onItemClick }) {

    function handleItemClick(suggestedRouteSlug) {
        onItemClick?.(suggestedRouteSlug)
    }

    return <div className="carousel carousel-center rounded-lg w-full space-x-4 flex-shrink-0">
            {
                sections.length > 0 && <div className="carousel-item p-0">
                </div>
            }
            {
                sections && sections.map((section) => {
                    console.log(`section: ${JSON.stringify(section)}`)
                    return <div className={`carousel-item w-2/3`}>
                        <RouteSuggestionItem name={section.name} description={section.description} image={section.photo} clickEvent={() => handleItemClick(section.slug)} />
                    </div>
                })
            }
            {
                sections.length > 0 && <div className="carousel-item p-0">
                </div>
            }
        </div>;
}
